import { Tooltip, type TooltipProps } from '@shared/components';

function TooltipMenu(props: Readonly<TooltipProps>) {
  return (
    <Tooltip
      placement='right-start'
      arrow={false}
      slotProps={{
        tooltip: {
          sx: (theme) => ({
            p: theme.spacing(0),
            m: theme.spacing(0),
            ml: theme.spacing(3),
            minWidth: 80,
            bgcolor: 'white',
            overflow: 'hidden',
            borderColor: 'grey.300',
            borderWidth: 1,
            borderStyle: 'solid',
            borderRadius: (theme) => theme.shape.rounded(2),
            color: 'text.primary',
            '.MuiListItemText-root': {
              p: theme.spacing(1.25, 2.5),
              m: theme.spacing(0),
            },
            '.MuiListItemIcon-root': {
              minWidth: 8,
              mr: theme.spacing(1),
              ml: theme.spacing(0.5),
              my: theme.spacing(1.75),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',

              '.MuiSvgIcon-root': {
                fontSize: 5,
              },
            },
            '.MuiListItemButton-root.Mui-selected': {
              bgcolor: 'white',
              '&:hover': {
                bgcolor: 'inherit',
              },

              '.MuiTypography-root': {
                fontWeight: 600,
              },
              '.MuiSvgIcon-root': {
                fontSize: 8,
                color: 'primary.darker',
              },
            },
          }),
        },
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 10],
              },
            },
          ],
        },
      }}
      {...props}
    />
  );
}

export default TooltipMenu;
